import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { COMPUTER_MAIN } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function ComputerPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${COMPUTER_MAIN}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
